// FanData: as antigas URLs de ajuda por funcionalidade (chwt.app/hc/*) foram
// removidas. Mantemos um unico guia externo — a documentacao da plataforma nativa,
// para quem quiser entender como ela funciona. Todos os "Saiba mais" apontam para ele.
export const NATIVE_PLATFORM_GUIDE_URL =
  'https://www.chatwoot.com/hc/user-guide/en';

export function getHelpUrlForFeature() {
  return NATIVE_PLATFORM_GUIDE_URL;
}
